import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<section class=\"content intro text-center\"><p><span class=\"small\">Start</span></p><h1>Stelle frei!<br>Gestalte eine Ausstellung</h1></section><section class=\"content text text-center\"><p> Du wolltest schon immer mal in einem Museum oder einer Sammlung arbeiten? Glück gehabt! Die Medizinsammlung sucht eine Kuratorin oder einen Kurator. Geplant ist eine Ausstellung zum Thema <span class=\"gapped-text\">«Unter die Haut – wie die Medizin dem Körper Geheimnisse entlockt»</span> Schaffst du es, 10 geeignete Objekte für die Ausstellung zusammenzustellen?</p></section><section class=\"content text text-center\"><p> Bei einigen Objekten findest du einen QR-Code. Schaue zuerst das Objekt an und denke nach, ob es in die Ausstellung passt. Scanne dann den Code, um herauszufinden, ob du richtigliegst. </p><p> Wenn du alle 10 Objekte gefunden hast, kriegst du vom Museumspersonal eine Belohnung. </p></section>", 3)
const _hoisted_4 = { class: "buttonlist" }
const _hoisted_5 = {
  key: 0,
  class: "text-center"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "small" }, "Dieses Spiel braucht Cookies um zu funktionieren. Mit Spiel starten stimmst du zu, dass Cookies auf deinem Gerät gespeichert werden dürfen.", -1)
const _hoisted_7 = [
  _hoisted_6
]

import { useRouter } from 'vue-router'
import { onMounted, computed, inject } from "vue";
import { useStore } from 'vuex'

// @ts-ignore
import { useStoryblokApi } from '@storyblok/vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const store = useStore()
const gamehandler: any = inject('gamehandler')

let hasActiveGame = computed<boolean>(() => {
  return gamehandler.countCollection() !== 0
})
let gameHasBeenWon = computed<boolean>(() => {
  return gamehandler.countCollection() === store.getters['getRequiredObjectCount']
})

let reset = () => {
  gamehandler.resetCollection()
  next()
}
let next = () => {
  router.push('/collection')
}

onMounted(() => {

})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_4, [
      (!_unref(hasActiveGame))
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _hoisted_7))
        : _createCommentVNode("", true),
      (!_unref(hasActiveGame))
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "light-bg",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(next) && _unref(next)(...args)))
          }, "Spiel starten"))
        : _createCommentVNode("", true),
      (_unref(hasActiveGame) && !_unref(gameHasBeenWon))
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: "light-bg",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(next) && _unref(next)(...args)))
          }, "Weiterspielen"))
        : _createCommentVNode("", true),
      (_unref(hasActiveGame) || _unref(gameHasBeenWon))
        ? (_openBlock(), _createElementBlock("button", {
            key: 3,
            class: "light-bg",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(reset) && _unref(reset)(...args)))
          }, "Neues Spiel"))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})